import cx from "classnames";
import { Container } from "modules/layout/ui/container";
import { useRouter } from "next/router";
import React, { CSSProperties } from "react";
import styles from "./with-sidebar-container.module.scss";

export interface IWithSidebarContainer {
  mainHref: string;
  sidebar?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
  fullWidth?: boolean;
}

export const WithSidebarContainer = (props: IWithSidebarContainer) => {
  const router = useRouter();

  const hideOnMobile = router.asPath === props.mainHref;

  return (
    <Container
      fullWidth={props.fullWidth}
      className={cx(styles.with_sidebar_container, props.className)}
      style={props.style}
      htmlId={props.htmlId}
    >
      <div className={styles.sidebar}>{props.sidebar}</div>
      <main className={cx(styles.main, hideOnMobile && styles.hide_on_mobile)}>{props.children}</main>
    </Container>
  );
};

WithSidebarContainer.defaultProps = {};
